import styled from 'styled-components';
import { PrimaryButton } from '@stax-core/truffle-components';
import { CenteredContent } from '../../components/CenteredContent';
import { formWidth } from '../../components/Constants';

export const headerHeight = 100;

export const LogoHeader = styled.div`
  padding: 1.6rem;
`;

export const DividerLine = styled.div`
  margin: 2rem 0;
  display: flex;
  justify-content: center;
  line-height: 1px;
  height: 0px;
  border-top: 1px solid #8d9799;
  span {
    background: #ffffff;
    display: inline-block;
    padding: 9px;
    margin-top: -22px;
  }
`;

export const Title = styled.h1`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 42px;
  color: #062333;
  margin-bottom: 1.6rem;
`;

export const FormSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 4rem);
`;

export const HaveAccount = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #8d9799;
  text-align: center;
  margin-bottom: 1rem;
  a {
    color: #009bf2;
  }
`;

export const Button = styled(PrimaryButton)`
  width: ${formWidth.tablet};
  height: 3.375rem;
  align-self: center;
`;

export const GoogleButton = styled(PrimaryButton)`
  background: #4285f5;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  width: ${formWidth.tablet};
  align-self: center;
`;

export const FieldWrapper = styled.div`
  margin: 0 0 12px;
`;

export const LayoutWithHeader = styled.div`
  display: grid;
  height: 100%;
  width: 100%;
`;

export const OffsetCenteredContent = styled(CenteredContent)`
  justify-self: center;
`;

export const Header = styled.header`
  padding: 12px 24px;
  align-items: center;
  justify-content: center;
  max-height: 100px;
`;
